import {ShareFn} from './share.types'

const WHATSAPP_SEND_URL = 'https://api.whatsapp.com/send'

export const buildWhatsAppShareLink: ShareFn = input => {
  const url = new URL(WHATSAPP_SEND_URL)
  url.searchParams.append('text', input.text)
  return url.toString()
}
